const sex_spots_2018 = [{
  message: "I had sex with a guy in the men's bathroom in Dwinelle, Floor C and then again the next week in the bathrooms on the GWS floor in Barrows. I would go in a stall and wait for him to knock twice on the stall door. He had great facial hair and wore a blue Patagonia jacket. I never got his name. ",
  lat: 37.870433,
  long: -122.260323,
}, {
  message: "I had sex with a guy in the men's bathroom in Dwinelle, Floor C and then again the next week in the bathrooms on the GWS floor in Barrows. I would go in a stall and wait for him to knock twice on the stall door. He had great facial hair and wore a blue Patagonia jacket. I never got his name. ",
  lat: 37.870039,
  long: -122.257984,
}, {
  message: 'Hot n heavy make out sesh',
  lat: 37.876458,
  long: -122.263455,
}, {
  message: 'He pulled down my pants in the Morrison Hall elevator and went to town! He was more familiar with the building than I was, so he convinced me that nobody uses it. I guess he was right, haha',
  lat: 37.870881,
  long: -122.256197,
}, {
  message: 'FPF Courtyard in the middle of the night, maybe 11PM. We were wandering around downtown not really knowing where we were headed, and then he pulled me into the middle of the courtyard and went down to a little corner. It was pretty exciting, he ate my ass, I fucked him, he came all over the concrete ground.',
  lat: 37.864715,
  long: -122.256101,
}, {
  message: "Before my first day at Berkeley over last summer, I never expected to become a promiscuous person. As a horny freshman as I was, though, I downloaded Grindr and checked the happenings around campus. I was greeted with a message from a senior who was working on campus at the moment. At first I didn't expect the conversation to go anywhere, but as we talked, I decided to meet up. Surprisingly, he asked me to meet up on campus in a Lab in Stanley and added that a third person would be watching. I'm not sure why I still thought that was a good idea on my first date but I went through with it. In the end, I didn't regret it and actually became friends with benefits with the guy. ",
  lat: 37.873943,
  long: -122.256353,
}, {
  message: 'The first time I hooked up with a guy we had sex on campus. It was a gameday and I would go on to date this guy for over a year. I told him it was a fantasy of mine to have sex against the campanile and he was like let’s do it. So we tried to have sex In the tree area by the campanile but it was like 9pm on a night gameday so there were too many people. We then moved to these random tables by haviland Hall I think and had pretty dope table sex. Anyways, that’s the story of the first time I hooked up with my then boyfriend.',
  lat: 37.87244,
  long: -122.257973,
}, {
  message: "A stressful dead week resulted in raunchy flirting with a study parter. We ended up sneaking into the women's bathroom in Moffitt and fucking against the bathroom stall door. I feel like all study buddies should double for this",
  lat: 37.872516,
  long: -122.260827,
}, {
  message: 'I slipped him some tongue, but I made have also slipped him something else if you know what I mean. ',
  lat: 37.870568,
  long: -122.257691,
}, {
  message: 'Got a blowjob in the Wheeler basement bathroom and used poppers for the first time.',
  lat: 37.87111,
  long: -122.259336,
}, {
  message: 'In one of those spur-of-the-moment events, got fingered in a random basement stairwell in Dwinelle after he convinced me that no one would pass us. ',
  lat: 37.870834,
  long: -122.261071,
}, {
  message: 'I got head through a gloryhole in Morrison Hall. It was bomb.',
  lat: 37.870805,
  long: -122.256439,
}, {
  message: 'It was wild ',
  lat: 37.871003,
  long: -122.253019,
}, {
  message: "Met a 'will they/won’t they' on campus at the stroke of midnight. A skateboarder was the only person nearby. Luckily, I think we escaped his line of sight, but the lawn of Li Ka Shing was alive that night. ",
  lat: 37.872778,
  long: -122.263155,
}, {
  message: 'Roof of MLK - the beauty of the skyline and my ass getting eaten',
  lat: 37.869082,
  long: -122.259684,
}, {
  message: 'Freshman year. I got on a Tinder date with a girl whom I hoped to be in a long-term relationship with. Sex was in the back of my mind, but I prioritized getting to know each other and spending time together more. However, during this first date, we walked through campus in the middle of the night, made out, and she sucked my dick near the Chancellor’s house. She got a boyfriend a week later. ',
  lat: 37.873956,
  long: -122.262468,
}, {
  message: 'My freshman year, I had sex with my girlfriend for the first time in the fire escape of Unit 1 where she was an RA. We were both wearing dresses and I thought everyone could see but quickly stopped caring. I felt like the coolest lesbian ever.',
  lat: 37.867783,
  long: -122.255184,
}, {
  message: 'I had sex in an Eshleman meeting room once. ',
  lat: 37.869298,
  long: -122.260022,
}, {
  message: 'Had a tinder date with the head of my major specific club. We made out in the grassy knoll above Bechtel and then headed *wink* up to the balcony of McCone where he worked (all after after hours!) ',
  lat: 37.874161,
  long: -122.259781,
}, {
  message: 'It was the night of my Haas acceptance. I did a lot of drugs, mainly coke. The night is somewhat blurry. I remember going to Strawberry Creek with this girl after the frat party. Things got really wet if you know what I mean. ',
  lat: 37.869992,
  long: -122.260387,
}, {
  message: '🙊 oops ',
  lat: 37.875137,
  long: -122.260891,
}, {
  message: 'I play the bells on the campanile. One night, I decided to take my girl friend up with me. As I was leaving, we got in the elevator and lets just say that as it went down so did she. I finished before the elevator got to the first floor.',
  lat: 37.872033,
  long: -122.257844,
}, {
  message: 'I had sex against the wall of the unit 2 fire escape',
  lat: 37.866537,
  long: -122.254218,
}, {
  message: 'Me and my partner, in a deserted stairwell. We only saw the sign that warned of video cameras after.',
  lat: 37.869071,
  long: -122.261473,
}, {
  message: 'Met up with a PHD student via Grindr who had lab access in VLSB. We went up to his lab, I gave him head, and we both came all over the lab floor. ¯\\_(ツ)_/¯ ',
  lat: 37.871449,
  long: -122.262291,
}, {
  message: "It was in a professor's office.  We knew we were meeting to flirt and mess around. We kissed and he touched me. It was after 8pm on a weekday. ",
  lat: 37.871465,
  long: -122.260365,
}, {
  message: "Me and my girlfriend had sex in one of the classrooms on the first floor of Barrows Hall during dead week. We turned the light off so the cleaning people wouldn't walk in on us.",
  lat: 37.869971,
  long: -122.258283,
}, {
  message: 'My first kiss',
  lat: 37.870382,
  long: -122.259593,
}, {
  message: "Soda is open 24 hours, if you have key card access. I was in 61B and this guy  from my lab were working on a project really late. We were sitting on the floor in the 2ndt floor hallway when he passed all his test cases. I leaned over to see the green bar in Intelli-J when he kissed me instead. Things got so steamy we just left our stuff in the hallway and fucked in the girl's  bathroom.",
  lat: 37.875497,
  long: -122.258649,
}, {
  message: "A study break with my girlfriend in the men's room handicap stall. What started as a bucket list item became a fairly regular thing. Let's just say we started making study plans more often. ",
  lat: 37.872512,
  long: -122.260644,
}, {
  message: 'When they were still finishing construction on the stadium my freshman year, we snuck into one of the rooms under construction and hooked up on this huge wooden table. It was terrifying and fun.',
  lat: 37.870822,
  long: -122.251675,
}, {
  message: 'Nothing gets you off like watching yourself get fucked in the mirror of the Eshleman basement bathroom . \nTwice.',
  lat: 37.869298,
  long: -122.259834,
}, {
  message: 'Office sex in Soda Hall',
  lat: 37.875395,
  long: -122.258799,
}, {
  message: 'Sex in one of those "Chemical Shower rooms" with a researcher',
  lat: 37.873181,
  long: -122.255806,
}, {
  message: 'I jerked off a man under the bridge at about 2 in the morning.',
  lat: 37.870348,
  long: -122.259411,
}, {
  message: 'Gave head in a stairwell in Bowles Hall, mostly so I could tell people I had sex in a castle.',
  lat: 37.873391,
  long: -122.25303,
}, {
  message: "Did it on the floor of an ASUC exec's office after hours... I got rug burn.",
  lat: 37.869124,
  long: -122.259912,
}, {
  message: 'We were driving on Hearst avenue and decided to stop in the road and park. He gave me head, and we would constantly felt the thrill as cars would pass by us. We were never caught and it the risky made it so much better. ',
  lat: 37.87512,
  long: -122.258987,
}, {
  message: 'During RRR week I fucked a guy in a classroom in Dwinelle during a "study date"',
  lat: 37.870741,
  long: -122.260488,
}, {
  message: "Everything was fine until I moaned my ex's name... who I'm still in love with... yikes. Still with my current boyfriend though so I guess he didn't mind?",
  lat: 37.873342,
  long: -122.252694,
}, {
  message: "There's a walkway around here that dead ends in a ledge. I blew a guy there once, but it was summer and  pretty late at night, so the chances of getting caught were minimal.",
  lat: 37.871051,
  long: -122.257367,
}, {
  message: ';)',
  lat: 37.874141,
  long: -122.258191,
}, {
  message: 'I lost my virginity',
  lat: 37.873905,
  long: -122.256203,
}, {
  message: 'We snuck into Evans Hall late at night to study for a midterm. It was 2 AM and we were really horny; things took off after that.',
  lat: 37.873456,
  long: -122.257823,
}, {
  message: "I was her GSI the prior year but we had never done anything with each other. We were walking through a bitterly cold Fall campus at 2am. It was the night of Daylight's Savings Time. We traipsed around on the walkways as she pointed out her favorite trees to climb and which buildings she had classes in. She eventually led me down a gully to her favorite spot to smoke weed: a sewer-like graffiti-covered tunnel through which Strawberry Creek snaked. I'd never had sex outdoors so I started making moves. We were wearing our winter clothes: me donning a military-style coat and her wearing her Cal sweater. We dropped our pants down to our knees, keeping our upper half's clothed to retain warmth. The cold air whisked over my hard dick. She bent over, her head facing a lewd graffiti marking on the wall. It didn't go in too easily, but I couldn't blame her. I chalked it up to the weather. I began to get aggressive but with every reckless thrust I would almost get knocked backward into the frigid creek. I found myself frequently regaining my footing on the precarious, roughed-up concrete. This distraction, combined with the freezing brisk air and relatively dry vagina really took me out of it. After 5 minutes or so of ridiculousness, I pulled out, neither of us having cum, and called it quits. We buttoned our pants and climbed back out of the ravine, laughing to ourselves about the silly experience. I thanked her for helping me lose my outdoor virginity and told her we should do it again sometime in a nice, cosy warm bed. She agreed. \n\nWe fucked and came like wild animals the next night.",
  lat: 37.87193,
  long: -122.256635,
}, {
  message: "I saw a very attractive young male in the hallway of my building with a 20 pack of pepsi while he was studying for biochem. As I passed by him, he said hi and offered me one of his many sugary drinks. Let's just say that's not the only sugary thing he gave me that day ;).",
  lat: 37.867358,
  long: -122.26073,
}, {
  message: 'My gf and I did hand stuff to each other on the 2nd level of Morrison hall during prime nap time.',
  lat: 37.870954,
  long: -122.256391,
}, {
  message: 'Had sex in Underhill freshman year with my girlfriend. 🍆 💦 all over the floor',
  lat: 37.867079,
  long: -122.255167,
}, {
  message: 'A friend of mine screwed in this dead-end stairwell on campus late at night near Evans, and emerged to find police searching around the building. Hopefully not looking for us... 😅',
  lat: 37.87393,
  long: -122.257772,
}, {
  message: 'Fingered my gf at the time in Wheeler Auditorium. We were sitting in the back and had a jacket over our laps covering. She came all over my long thing fingers',
  lat: 37.871339,
  long: -122.259239,
}, {
  message: 'Celebrated partners new birth control implant by having sex in the African American history section in mainstacks. ',
  lat: 37.872647,
  long: -122.259652,
}, {
  message: 'Took advantage of an unnamed clubs MLK access on more than one occasion.',
  lat: 37.869293,
  long: -122.260167,
}, {
  message: 'Splish splash I got a cumshot in the fountain. Seriously one of the scariest/most exhilarating moments of my life.',
  lat: 37.873668,
  long: -122.256993,
}, {
  message: "Doggystyle at the Big C. I'm pretty sure the LBNL cameras saw us. We finished before a group of girls came up, thank god.",
  lat: 37.874379,
  long: -122.249508,
}, {
  message: 'Dry-humped the GF in the Cal Band library room',
  lat: 37.869672,
  long: -122.260465,
}, {
  message: 'Sex in a squash court at RSF',
  lat: 37.868595,
  long: -122.262664,
}, {
  message: 'I took the girl I was dating up on to campus and up a stairwell. We had sex while people watching through the semi frosted glass!',
  lat: 37.873925,
  long: -122.256279,
}, {
  message: 'South Hall stairs on a Saturday are pretty empty. And the acoustics are amazing! ;-)',
  lat: 37.871326,
  long: -122.258504,
}, {
  message: 'My girlfriend and I had just started dating. Lacking privacy in our dorms we headed to the lobby bathroom after the door monitor left at night for a quick round of fun.',
  lat: 37.868142,
  long: -122.255055,
}, {
  message: 'My ugsi smoked me out and fucked me in a hallway in first floor Soda. Not the first time I\'ve been "fucked" in Soda but the only time I was happy about it!',
  lat: 37.875692,
  long: -122.257319,
}, {
  message: 'I was in an orgy after a wild cz party',
  lat: 37.875613,
  long: -122.261723,
}, {
  message: 'Me: "Will you go to bed with me?"\nHer: "Come and get it like a bitch-funky sex machine!"',
  lat: 37.869724,
  long: -122.251654,
}, {
  message: "I fingered and got a blowjob from someone on the brick stairs at the base of the Campanile. It happened a while ago, so I don't remember all the details, but it was late at night and we were wandering around campus for a while looking for a deserted space. We met on yik yak, that's how long ago this was. ",
  lat: 37.872334,
  long: -122.258134,
}, {
  message: 'Roof of the teachers lounge. It was pretty bangin',
  lat: 37.871911,
  long: -122.255931,
}, {
  message: "What doesn't kill you only makes you...stranger.",
  lat: 37.872033,
  long: -122.257796,
}, {
  message: 'I hooked up in the bathroom of mainstacks bc why not? Thx tindr',
  lat: 37.872821,
  long: -122.260559,
}, {
  message: 'Hooked up with my current boyfriend the very first night we met in one of the soda study lounges at 3am. a wild start to a wild relationship',
  lat: 37.87573,
  long: -122.257603,
}];

const sex_spots_2026 = [{
  message: 'I had sex with a guy in the men\'s bathroom in Dwinelle, Floor C and then again the next week in the bathrooms on the GWS floor in Barrows. I would go in a stall and wait for him to knock twice on the stall door. He had great facial hair and wore a blue Patagonia jacket. I never got his name. ',
  lat: 37.87357063974425,
  long: -122.25437171170218,
}, {
  message: 'I had sex with a guy in the men\'s bathroom in Dwinelle, Floor C and then again the next week in the bathrooms on the GWS floor in Barrows. I would go in a stall and wait for him to knock twice on the stall door. He had great facial hair and wore a blue Patagonia jacket. I never got his name. ',
  lat: 37.870039,
  long: -122.257984,
}];

export { sex_spots_2018, sex_spots_2026 };
